import { Injectable } from '@angular/core';
import { Storage } from '@ionic/storage';
/*import { Http, Headers, RequestOptions } from '@angular/http';*/
import 'rxjs/add/operator/map';

// ---- COMMON MODULES ---- //
import { Functions } from './functions';

@Injectable()
export class UserdataModel {
    userdata: any=[];

    constructor(private storage: Storage, public functions: Functions){
        this.getUserdataStored();
    }

    setUserdata(
        /* --- PROFILE DATA --- */
        guidUser:string,
        username:string,
        email:string,
        password:string,
        fullname:string,
        sex:string,
        education:string,
        birthDate:string,  //"1980-11-04"

        picture:string,
        creationDate:string,
        language:string,
        spokenLanguages:string,
        roles:string,
        lastAccess:string,
        lastLogin:string,
        link:string,
        cancelLink:string,
        
        /* --- GAMEDATA --- */
        score:number,
        level: number,
        numberOfLogin:number,
        collectiblesGot:any,
        booksinfo:any,
        settingsCurrentGamemode:any,
        settingsCurrentDifficulty:any,
        settingsCurrentLanguage:any,
        settingsCurrentSoundEffectStatus:number,
        settingsCurrentMusicVolume:number,
        settingsCurrentCatChosen:string,

        /* --- SESSION DATA --- */
        token:string,
        session_name:string,
        sessid:string
        ){
        return new Promise((resolve) =>{
            
            if(guidUser!="") {this.userdata[0].guidUser=guidUser;}
            if(username!="") {this.userdata[0].username=username;}
            if(email!="") {this.userdata[0].email=email;}
            if(password!="") {this.userdata[0].password=password;}
            if(fullname!="") {this.userdata[0].fullname=fullname;}
            if(sex!="") {this.userdata[0].sex=sex;}
            if(education!="") {this.userdata[0].education=education;}
            if(birthDate!="") {this.userdata[0].birthDate=birthDate;}

            if(picture!="") {this.userdata[0].picture=picture;}
            if(creationDate!="") {this.userdata[0].creationDate=creationDate;}
            if(language!="") {this.userdata[0].language=language;}
            if(spokenLanguages!="") {this.userdata[0].spokenLanguages=spokenLanguages;}
            if(roles!="") {this.userdata[0].roles=roles;}
            if(lastAccess!="") {this.userdata[0].lastAccess=lastAccess;}
            if(lastLogin!="") {this.userdata[0].lastLogin=lastLogin;}
            if(link!="") {this.userdata[0].link=link;}
            if(cancelLink!="") {this.userdata[0].cancelLink=cancelLink;}

            if(score!=-1) {this.userdata[0].score=score;}
            if(level!=-1) {this.userdata[0].level=level;}
            if(numberOfLogin!=-1) {this.userdata[0].numberOfLogin=numberOfLogin;}
            if(booksinfo!="") {this.userdata[0].booksinfo=booksinfo;}
            if(collectiblesGot!="") {this.userdata[0].collectiblesGot=collectiblesGot;}
            if(settingsCurrentGamemode!="") {this.userdata[0].settingsCurrentGamemode=settingsCurrentGamemode;}
            if(settingsCurrentDifficulty!="") {this.userdata[0].settingsCurrentDifficulty=settingsCurrentDifficulty;}
            if(settingsCurrentLanguage!="") {this.userdata[0].settingsCurrentLanguage=settingsCurrentLanguage;}
            if(settingsCurrentSoundEffectStatus!=-1) {this.userdata[0].settingsCurrentSoundEffectStatus=settingsCurrentSoundEffectStatus;}
            if(settingsCurrentMusicVolume!=-1) {this.userdata[0].settingsCurrentMusicVolume=settingsCurrentMusicVolume;}
            if(settingsCurrentCatChosen!="") {this.userdata[0].settingsCurrentCatChosen=settingsCurrentCatChosen;}
           
            if(token!="") {this.userdata[0].token=token;}
            if(session_name!="") {this.userdata[0].session_name=session_name;}
            if(sessid!="") {this.userdata[0].sessid=sessid;}
            
            this.storeUserdata().then((response)=>{
                resolve("UserDataStored");
            });
        });
    }

    isCurrentBookComplete(){
        var idBook=this.functions.getIdCurrentBook();
        return this.isBookComplete(idBook);
    }

    isCurrentBookBeginned(){
        var idBook=this.functions.getIdCurrentBook();
        return this.isBookBeginned(idBook);
    }

    isBookComplete(idBook){
        if(this.getBookmarkofBook(idBook)<0 
        || (this.getNumsnttotalofBook(idBook)!=0 &&this.getBookmarkofBook(idBook)>=this.getNumsnttotalofBook(idBook))
        || this.getBookmarkLetterofBook(idBook)<0
        || (this.getIndexLastCharacterInBookOfBook(idBook)!=0 && this.getBookmarkLetterofBook(idBook)>this.getIndexLastCharacterInBookOfBook(idBook))){
            return true;
        }else{
            return false;
        }
    }

    isBookBeginned(idBook){
        if((this.getBookmarkofBook(idBook)>0 || this.getBookmarkLetterofBook(idBook)>0)
        && (this.getBookmarkLetterofBook(idBook)<this.getIndexLastCharacterInBookOfBook(idBook))){
            return true;
        }else{
            return false;
        }  
    }

    /* --------- GETTER/SETTER --------- */

    setWholeUserdata(userdata){
        this.userdata[0]=userdata;
        this.storeUserdata();
    }

    getWholeUserdata(){
        return this.userdata[0];   
    }

    storeUserdata(){
        return new Promise((resolve) =>{
        this.storage.set('userdata', JSON.stringify(this.userdata)).then((response)=>{
            resolve("UserDataStoredLocally");
          });
        });
    }

    getUserdataStored(){
        this.storage.get('userdata').then((userdata) => {
            if(userdata){
                this.userdata=JSON.parse(userdata);
            }else{
                this.userdata.push({});
            }
        });
    }

    clearUserdata(){
        return new Promise((resolve) =>{
            this.userdata=[];
            this.userdata.push({});
            this.storeUserdata().then((response)=>{
                resolve("storeUserdataOk");
            });
        });
    }

    setGuidUser(guidUser){
        this.userdata[0].guidUser=guidUser;
        this.storeUserdata();
    };

    getGuidUser(){
        return this.userdata[0].guidUser;
    };

    setUsername(username){
        this.userdata[0].username=username;
        this.storeUserdata();
    };

    getUsername(){
        return this.userdata[0].username;
    };

    setEmail(email){
        this.userdata[0].username=email;
        this.storeUserdata();
    };

    getEmail(){
        return this.userdata[0].email;
    };

    setPassword(password){
        this.userdata[0].username=password;
        this.storeUserdata();
    };

    getPassword(){
        return this.userdata[0].password;
    };

    setFullname(fullname){
        this.userdata[0].username=fullname;
        this.storeUserdata();
    };

    getFullname(){
        return this.userdata[0].fullname;
    };

    setSex(sex){
        this.userdata[0].sex=sex;
        this.storeUserdata();
    };

    getSex(){
        return this.userdata[0].sex;
    };

    setEducation(education){
        this.userdata[0].education=education;
        this.storeUserdata();
    };

    getEducation(){
        return this.userdata[0].education;
    };

    setBirthDate(birthDate){
        this.userdata[0].birthDate=birthDate;
        this.storeUserdata();
    };

    getBirthDate(){
        return this.userdata[0].birthDate;
    };

    setLanguage(language){
        this.userdata[0].language=language;
        this.storeUserdata();
    };

    getLanguage(){
        return this.userdata[0].language;
    };

    setScore(score){
        this.userdata[0].score=score;
        this.storeUserdata();
    };

    getScore(){
        return this.userdata[0].score;
    };

    setLevel(level){
        this.userdata[0].level=level;
        this.storeUserdata();
    };

    getLevel(){
        return this.userdata[0].level;
    };

    setNumberOfLogin(numberOfLogin){
        this.userdata[0].numberOfLogin=numberOfLogin;
        this.storeUserdata();
    };

    getNumberOfLogin(){
        return this.userdata[0].numberOfLogin;
    };

    setBooksinfo(booksinfo){
        this.userdata[0].booksinfo=booksinfo;
        this.storeUserdata();
    };

    getBooksinfo(){
        return this.userdata[0].booksinfo;
    };

    setCollectibleGot(idCollectible){
        if (this.functions.isObjectEmpty(this.userdata[0].collectiblesGot)) { 
            this.userdata[0].collectiblesGot=[{
                idCollectible: idCollectible,
                idBook:this.functions.getIdCurrentBook()
            }];
        }else{
            this.userdata[0].collectiblesGot.push({
                idCollectible: idCollectible,
                idBook:this.functions.getIdCurrentBook()
            });
        }
        this.storeUserdata();
    };

    getCollectiblesGot(){
        return this.userdata[0].collectiblesGot;
    };

    isGotCollectibleNum(idCollectible){
        var filtered = this.getCollectiblesGot();
        //console.log("+++filtered: "+JSON.stringify(filtered));
        //console.log("+++filtered.length: "+JSON.stringify(filtered.length));
        //console.log("+++filtered: "+this.functions.isObjectEmpty(filtered));
        if (!this.functions.isObjectEmpty(filtered)) { 
            filtered = filtered.filter(function (item) {
                return (item.idCollectible == idCollectible);
            })
            if (filtered.length==0) { console.log("false"); return false; } else { console.log("true"); return true; }
        }else{
            return false;
        }
    }

    isGotCollectibleNumForBook(idCollectible, idBook){
        var filtered = this.getCollectiblesGot();
        if (filtered.length!=0) {
            filtered = filtered.filter(function (item) {
                return ((item.idCollectible == idCollectible) && (item.idBook == idBook));
            })
        }

        if (filtered.length==0) { return false; }else{ return true; }
    }

    setSettingsCurrentGamemode(settingsCurrentGamemode){
        this.userdata[0].settingsCurrentGamemode=settingsCurrentGamemode;
        this.storeUserdata();
    };

    getSettingsCurrentGamemode(){
        return this.userdata[0].settingsCurrentGamemode;
    };

    setSettingsCurrentDifficulty(settingsCurrentDifficulty){
        this.userdata[0].settingsCurrentDifficulty=settingsCurrentDifficulty;
        this.storeUserdata();
    };

    getSettingsCurrentDifficulty(){
        return this.userdata[0].settingsCurrentDifficulty;
    };

    setSettingsCurrentLanguage(settingsCurrentLanguage){
        this.userdata[0].settingsCurrentLanguage=settingsCurrentLanguage;
        this.storeUserdata();
    };

    getSettingsCurrentLanguage(){
        return this.userdata[0].settingsCurrentLanguage;
    };

    setSettingsCurrentSoundEffectStatus(settingsCurrentSoundEffectStatus){
        this.userdata[0].settingsCurrentSoundEffectStatus=settingsCurrentSoundEffectStatus;
        this.storeUserdata();
    };

    getSettingsCurrentSoundEffectStatus(){
        return this.userdata[0].settingsCurrentSoundEffectStatus;
    };

    setSettingsCurrentMusicVolume(settingsCurrentMusicVolume){
        this.userdata[0].settingsCurrentMusicVolume=settingsCurrentMusicVolume;
        this.storeUserdata();
    };

    getSettingsCurrentMusicVolume(){
        return this.userdata[0].settingsCurrentMusicVolume;
    };

    setSettingsCurrentCatChosen(settingsCurrentCatChosen){
        this.userdata[0].settingsCurrentCatChosen=settingsCurrentCatChosen;
        this.storeUserdata();
    };

    getSettingsCurrentCatChosen(){
        return this.userdata[0].settingsCurrentCatChosen;
    };

    setToken(token){
        this.userdata[0].token=token;
        this.storeUserdata();
    };

    getToken(){
        return this.userdata[0].token;
    };

    setSession_name(session_name){
        this.userdata[0].session_name=session_name;
        this.storeUserdata();
    };

    getSession_name(){
        return this.userdata[0].session_name;
    };

    setSessid(sessid){
        this.userdata[0].sessid=sessid;
        this.storeUserdata();
    };

    getSessid(){
        return this.userdata[0].sessid;
    };

    /* --------- GETTER/SETTER BOOKSINFO --------- */

    addSkip(numSkip){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].skip=this.userdata[0].booksinfo[idBook-1].skip+numSkip;
        this.storeUserdata();
    };

    useSkip(){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].skip--;
        this.storeUserdata();
    };

    getSkip(){
        var idBook=this.functions.getIdCurrentBook();
        return this.userdata[0].booksinfo[idBook-1].skip;
    };

    getLanguageofBook(idBook){
        return this.userdata[0].booksinfo[idBook-1].language;
    };

    getGamemodeofBook(idBook){
        return this.userdata[0].booksinfo[idBook-1].gamemode;
    };

    getBookmark(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].bookmark);
    };

    getBookmarkofBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].bookmark);
    };

    getBookmarkLetter(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].bookmarkLetter);
    };

    getBookmarkLetterofBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].bookmarkLetter);
    };

    getCurrentIdChunkInBook(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].currentIdChunkInBook);
    };

    getCurrentIdChunkInBookOfBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].currentIdChunkInBook);
    };

    getCurrentIdChunkInBookForViz(){
        return this.getCurrentIdChunkInBook()+1;
    };

    getCurrentIdChunkInBookOfBookForViz(idBook){
        return this.getCurrentIdChunkInBookOfBook(idBook)+1;
    };

    getCurrentNumLettersGuessedInCurrentChunk(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].currentNumLettersGuessedInCurrentChunk);
    };

    getCurrentNumLettersGuessedInCurrentChunkOfBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].currentNumLettersGuessedInCurrentChunk);
    };

    getNumsnttotal(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].numsnttotal);
    };

    getNumsnttotalofBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].numsnttotal);
    };

    getCurrentTime(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].currentTime);
    };

    getCurrentChunkScore(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].currentChunkScore);
    };

    getNumchunktotal(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].numchunktotal);
    };

    getNumchunktotalOfBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].numchunktotal);
    };

    getNumchunkRemaining(){
        var idBook=this.functions.getIdCurrentBook();
        var gamemode=this.getGamemodeofBook(idBook);

        
        if (gamemode.indexOf("reverse") > -1) { // is reverse
            return this.getCurrentIdChunkInBookOfBook(idBook)+1;
        }else{
            // getNumchunktotalOfBook is 1-N and getCurrentIdChunkInBookOfBook 0-N so here it is the +1
            // +1 for the current chunk is unfinished so is out of the calculation
            return (this.getNumchunktotalOfBook(idBook)-((this.getCurrentIdChunkInBookOfBook(idBook)+1))+1);
        }
    }

    getNumchunkRemainingOfBook(idBook){
        var gamemode=this.getGamemodeofBook(idBook);

       
        if (gamemode.indexOf("reverse") > -1) { // is reverse
            return this.getCurrentIdChunkInBookOfBook(idBook)+1;
        }else{
            // getNumchunktotalOfBook is 1-N and getCurrentIdChunkInBookOfBook 0-N so here it is the +1
            // +1 for the current chunk is unfinished so is out of the calculation
            return (this.getNumchunktotalOfBook(idBook)-((this.getCurrentIdChunkInBookOfBook(idBook)+1))+1);
        }
    }

    getIndexLastCharacterInBook(){
        var idBook=this.functions.getIdCurrentBook();
        return parseInt(this.userdata[0].booksinfo[idBook-1].indexlastcharacterinbook);
    };

    getIndexLastCharacterInBookOfBook(idBook){
        return parseInt(this.userdata[0].booksinfo[idBook-1].indexlastcharacterinbook);
    };

    setBookmark(bookmark){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].bookmark=bookmark;
        this.storeUserdata();
    };

    setBookmarkLetter(bookmarkLetter){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].bookmarkLetter=bookmarkLetter;
        this.storeUserdata();
    };

    setCurrentIdChunkInBook(currentIdChunkInBook){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].currentIdChunkInBook=currentIdChunkInBook;
        this.storeUserdata();
    };

    setCurrentNumLettersGuessedInCurrentChunk(currentNumLettersGuessedInCurrentChunk){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].currentNumLettersGuessedInCurrentChunk=currentNumLettersGuessedInCurrentChunk;
        this.storeUserdata();
    }
    
    setNumsnttotal(numsnttotal){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].numsnttotal=numsnttotal;
        this.storeUserdata();
    };
    
    setIndexLastCharacterInBook(indexlastcharacterinbook){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].indexlastcharacterinbook=indexlastcharacterinbook;
        this.storeUserdata();
    };

    setNumchunktotal(numchunktotal){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].numchunktotal=numchunktotal;
        this.storeUserdata();
    };

    setCurrentTime(currentTime){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].currentTime=currentTime;
        this.storeUserdata();
    };

    setCurrentChunkScore(currentChunkScore){
        var idBook=this.functions.getIdCurrentBook();
        this.userdata[0].booksinfo[idBook-1].currentChunkScore=currentChunkScore;
        this.storeUserdata();
    };

    /* --------- END --------- GETTER/SETTER --------- */
}


// WEBPACK FOOTER //
// ./src/providers/userdata-model.ts